import {
  GET_ALLOCATORS,
  GET_MY_FUND,
  GET_MEETINGS,
  GET_RECENT_CHAT,
  GET_RECENT_POST,
  GET_DASHBOARD_CONFIG,
  UPDATE_DASHBOARD_CONFIG,
  GET_STAGE_ALLOCATION,
} from "./constants.js";

export function getDashboardAllocators(payload) {
  return {
    type: GET_ALLOCATORS,
    payload,
  };
}

export function getMyFunds(payload) {
  return {
    type: GET_MY_FUND,
    payload,
  };
}

export function getMeetings(payload) {
  return {
    type: GET_MEETINGS,
    payload,
  };
}

export function getRecentChats(payload) {
  return {
    type: GET_RECENT_CHAT,
    payload,
  };
}

export function getRecentPost(payload) {
  return {
    type: GET_RECENT_POST,
    payload,
  };
}

export function getDashboardConfig(callback) {
  return {
    type: GET_DASHBOARD_CONFIG,
    callback,
  };
}
export function updateDashboardConfig(payload, callback) {
  return {
    type: UPDATE_DASHBOARD_CONFIG,
    payload,
    callback,
  };
}

export function getStageAllocationCount() {
  return {
    type: GET_STAGE_ALLOCATION,
  };
}